import React from "react";
import EntityListPage from "../pages/EntityListPage";

/** Merkez hub sekmelerinde gömülü entity listesi — backend değişmez. */
export default function EmbeddedEntityList({ entityKey }) {
    return <EntityListPage entityKeyOverride={entityKey} embedded />;
}
